import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext'; // Import useAuth
import {
  Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Paper, // New imports
  IconButton
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

function EmpresaList({ refresh, onEdit, onEmpresaDeleted }) {
  const { user } = useAuth(); // Get user from context
  const [empresas, setEmpresas] = useState([]);

  const fetchEmpresas = () => {
    api.get('/empresas')
      .then(response => {
        setEmpresas(response.data.data || response.data);
      })
      .catch(error => {
        console.error('Erro ao buscar empresas:', error);
      });
  };

  useEffect(() => {
    fetchEmpresas();
  }, [refresh, user]); // Add user to dependency array

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja deletar esta empresa?')) {
      try {
        await api.delete(`/empresas/${id}`);
        console.log('Empresa deletada com sucesso!');
        onEmpresaDeleted();
      } catch (error) {
        console.error('Erro ao deletar empresa:', error);
      }
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Nome</TableCell>
            <TableCell>CNPJ</TableCell>
            <TableCell>Timezone</TableCell>
            <TableCell>WhatsApp Instance</TableCell>
            {(user && (user.tipo_usuario === 'admin' || user.tipo_usuario === 'sindico')) && <TableCell>Acoes</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {empresas.map((empresa) => (
            <TableRow
              key={empresa.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              hover={true} // Enable hover effect
            >
              <TableCell component="th" scope="row">{empresa.id}</TableCell>
              <TableCell>{empresa.nome}</TableCell>
              <TableCell>{empresa.cnpj || 'N/A'}</TableCell>
              <TableCell>{empresa.timezone || 'America/Sao_Paulo'}</TableCell>
              <TableCell>{empresa.whatsapp_instance || '-'}</TableCell>
              {(user && (user.tipo_usuario === 'admin' || (user.tipo_usuario === 'sindico' && user.empresa_id === empresa.id))) && (
                <TableCell>
                  <IconButton aria-label="edit" onClick={() => onEdit(empresa)}>
                    <EditIcon />
                  </IconButton>
                  {(user && user.tipo_usuario === 'admin') && ( // Only admin can delete
                    <IconButton aria-label="delete" onClick={() => handleDelete(empresa.id)}>
                      <DeleteIcon />
                    </IconButton>
                  )}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default EmpresaList;
